import { Row, Col, Button, Popconfirm, message } from "antd"
import req from '../request'

const App = props => {
    const handleDial = () => {
        req.post('/api/return',{action:'dialPhone',phone:props.item.phone,id: props.item.id}).then(r=>{
            console.log(r);
            if(r.status === 'done'){
                message.success('呼叫成功')
                props.refresh && props.refresh()
            }else{
                message.error(r.msg)
            }
        })
    }
    return <Row>
        <Col>{props.phone && props.phone}</Col>
        <Col>
            <Popconfirm
                title={'呼叫:'+props.phone + ' ?' }
                onConfirm={handleDial}
                // onCancel={cancel}
                okText="打"
                cancelText="等下"
            >
                <Button size='small' type='link'>拨号</Button>
            </Popconfirm>
        </Col>
    </Row>
}

export default App